<div class="full-height layout-column">
  <chat-conversation-view *ngIf="!!conversation"
                          class="flex fade-element-in-only"
                          [conversation]="conversation">

  </chat-conversation-view>
</div>
